import React, { useEffect, useRef, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  Chip,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
  Paper,
  Divider,
  Avatar,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { Form, Formik } from "formik";
import AddIcon from "@mui/icons-material/Add";
import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import Tempautocomplete from "../../component/autocomplete/Tempautocomplete";
import CloseIcon from "@mui/icons-material/Close";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { convertToRaw, convertFromHTML, ContentState, EditorState } from "draft-js";
import {
  GetScheduleSendMailUsing365Service,
  GetSendMailUsing365Service,
  GetForwardMailUsing365Service,
} from "../../Redux/service/MailService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useDispatch, useSelector } from "react-redux";
import { GetMailTemplateAction } from "../../Redux/action/EmailAction";
import { useNavigate } from "react-router-dom";

const FormSectionCard = styled(Paper)(({ theme }) => ({
  padding: "32px",
  borderRadius: "12px",
  backgroundColor: "#ffffff",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.03)",
  border: "1px solid #e2e8f0",
}));

const FieldContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  width: "100%",
});

const SectionLabel = styled(Typography)({
  fontFamily: FontFamily.Nunito,
  fontWeight: fontWeight.W700,
  fontSize: "13px",
  color: "#94a3b8",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
});

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 440,
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.1)",
  p: 4,
};

export const AddNewMailPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const childRef = useRef(null);
  const formikRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [selections, setSelections] = useState([]);
  const [formLoading, setFormLoading] = useState(false);
  const [b_description, setB_Description] = useState();
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const [EmailTemplateList, setEmailTemplateList] = useState([]);
  const [templateData, settemplateData] = useState();
  const [reminderdatatime, setReminderdatatime] = useState();
  const [messageId,setMessageId]=useState("");
  const [originalHtml, setOriginalHtml] = useState("");
  const [isForward, setIsForward] = useState(false);
  const [formInitialValues, setFormInitialValues] = useState({
    attachments: [],
    subject: "",
    otherto: "",
    body: "",
  });

  useEffect(() => {
    dispatch(GetMailTemplateAction());
  }, [dispatch]);

  const EditEmailTemplatedataState = useSelector(
    (state) => state.email?.emailTemplate?.data?.emailTemplates
  );

  const ReplyEmailPayload = useSelector((state) => state.email.ReplyEmailPayload);

  useEffect(() => {
    const updatedData = EditEmailTemplatedataState?.map(({ templateName, ...rest }) => ({
      title: templateName,
      ...rest,
    }));
    setEmailTemplateList(updatedData || []);
  }, [EditEmailTemplatedataState]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleReminderSave = () => {
    setOpen(false);
    if (reminderdatatime != null) {
      handleFromSubmit(formikRef.current.values, "schedule_send_mail");
    }
  };

  const handleSelectionChange = (newSelections) => setSelections(newSelections);

  const handleDelete = (name) => {
    setSelections((prevSelections) =>
      prevSelections.filter((selection) => selection.name !== name)
    );
  };

  useEffect(() => {
    if (!ReplyEmailPayload) {
      setSelections([]);
      return;
    }
    const selectedEmail = ReplyEmailPayload?.selectedEmail || {};
    console.log(selectedEmail);
    
    let replyTo = "";
    const isForwardMode = selectedEmail?.type === "forward";
    setIsForward(isForwardMode);

    if (isForwardMode) {
      replyTo = "";
    } else if (selectedEmail?.from && selectedEmail.from !== "Unknown") {
      replyTo = selectedEmail.from;
    } else if (selectedEmail?.to && Array.isArray(selectedEmail.to)) {
      replyTo = selectedEmail.to.join(",");
    } else if (typeof selectedEmail?.to === "string") {
      replyTo = selectedEmail.to;
    }

    const replySubject = selectedEmail?.subject || "";
    const replyBody = ReplyEmailPayload?.mailBody || "";
    const replyAttachments = ReplyEmailPayload?.attachments || [];
    setMessageId(ReplyEmailPayload.selectedEmail.id);
    setFormInitialValues({
      attachments: replyAttachments,
      subject: replySubject,
      otherto: replyTo,
      body: replyBody,
    });

    if (formikRef.current) {
      formikRef.current.setFieldValue("attachments", replyAttachments);
      formikRef.current.setFieldValue("subject", replySubject);
      formikRef.current.setFieldValue("otherto", replyTo);
    }
    // Do NOT load replyBody into DraftJS as it mangles complex HTML and styles.
    // Keep it in originalHtml state to be appended on submit and rendered below the editor.
    setEditorState(EditorState.createEmpty());
    setOriginalHtml(replyBody);
  }, [ReplyEmailPayload]);

  useEffect(() => {
    if (templateData) {
      formikRef.current.setFieldValue("subject", templateData.subject);
      const blocksFromHTML = convertFromHTML(templateData?.body);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorState(EditorState.createWithContent(contentState));
      formikRef.current.setFieldValue("body", templateData?.body);
    }
  }, [templateData]);

  const handleFromSubmit = async (values, type) => {
    setFormLoading(true);
    const cc = selections?.filter((data) => data.value === "cc")?.map((data) => data.email) || [];
    const bcc = selections?.filter((data) => data.value === "bcc")?.map((data) => data.email) || [];
    const to = selections?.filter((data) => data.value === "to")?.map((data) => data.email) || [];

    if (values.otherto) {
      const externalEmails = values.otherto.split(",").map(e => e.trim()).filter(Boolean);
      to.push(...externalEmails);
    }

    if (to.length === 0) {
      dispatch(showSnackbar("Recipient email address ('To') is required.", "error"));
      setFormLoading(false);
      return;
    }
    if (!values.subject || values.subject.trim() === "") {
      dispatch(showSnackbar("Subject line is required.", "error"));
      setFormLoading(false);
      return;
    }
    
    let finalBody = (values.body && values.body !== "<p></p>\n") ? values.body : "";
    if (originalHtml) {
      if (!isForward) {
        finalBody += `<br/><br/><div style="border-top: 1px solid #e2e8f0; padding-top: 16px;">${originalHtml}</div>`;
      }
    }

    if (!finalBody || finalBody.trim() === "") {
      dispatch(showSnackbar("Email message body is required.", "error"));
      setFormLoading(false);
      return;
    }

    values["body"] = finalBody;
    values["to"] = to;
    values["cc"] = cc;
    values["bcc"] = bcc;
    values["accessToken"] = window.sessionStorage.getItem("ms_auth");
    values["messageId"] = messageId;
    values["forwardBody"] = finalBody;
    values["toRecipients"] = to; // Pass toRecipients for the forward endpoint

    try {
      if (type === "send_mail") {
        let res;
        if (isForward) {
          res = await GetForwardMailUsing365Service(values);
        } else {
          res = await GetSendMailUsing365Service(values);
        }
        if (res.status === 200) {
          dispatch(showSnackbar("Email Sent Successfully.", "success"));
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      } else if (type === "schedule_send_mail") {
        values["sendAt"] = reminderdatatime;
        const res = await GetScheduleSendMailUsing365Service(values);
        if (res.status === 200) {
          dispatch(showSnackbar("Email Scheduled Successfully.", "success"));
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      }
    } catch (e) {
      dispatch(showSnackbar(e.response?.data?.message || "Something went wrong", "error"));
    } finally {
      setFormLoading(false);
    }
  };

  const renderChipGroup = (type, title) => {
    const filtered = selections?.filter((data) => data.value === type);
    if (!filtered || filtered.length === 0) return null;

    return (
      <Box sx={{ mt: 1.5 }}>
        <Typography
          fontFamily={FontFamily.Poppins}
          fontSize="13px"
          fontWeight={fontWeight.W500}
          color="#64748b"
          sx={{ mb: 0.5 }}
        >
          {title}
        </Typography>
        <Stack direction="row" flexWrap="wrap" gap={1}>
          {filtered.map((data) => (
            <Chip
              key={data.name}
              avatar={<Avatar sx={{ bgcolor: `${ThemeColor.PURPLE}20`, color: ThemeColor.PURPLE, fontSize: "12px" }}>{data.email[0].toUpperCase()}</Avatar>}
              label={data.email}
              onDelete={() => handleDelete(data.name)}
              deleteIcon={<CloseIcon sx={{ fontSize: "16px !important" }} />}
              sx={{
                background: "#f1f5f9",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                "& .MuiChip-label": { fontFamily: FontFamily.Nunito, fontWeight: fontWeight.W600, color: "#334155" },
              }}
            />
          ))}
        </Stack>
      </Box>
    );
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/CAE/webmail")}
        sx={{
          color: "#64748b",
          textTransform: "none",
          fontFamily: FontFamily.Poppins,
          mb: 2,
          fontWeight: 600,
          "&:hover": { color: "#0f172a", backgroundColor: "rgba(0, 0, 0, 0.02)" }
        }}
      >
        Back to Inbox
      </Button>

      {/* Page Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
        <Box>
          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={fontWeight.W700}
            fontSize="28px"
            color="#0f172a"
          >
            Compose Mail
          </Typography>
          <Typography
            fontFamily={FontFamily.Poppins}
            fontSize="14px"
            fontWeight={fontWeight.W400}
            color="#64748b"
          >
            Create, design, and dispatch your custom platform message
          </Typography>
        </Box>
      </Box>

      <Formik
        innerRef={formikRef}
        enableReinitialize
        initialValues={formInitialValues}
        onSubmit={async (values) => {
          handleFromSubmit(values, "send_mail");
        }}
      >
        {({ values, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              {/* Full Width Layout */}
              <Grid item xs={12} lg={12} sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <FormSectionCard>
                  <Stack spacing={3}>
                    {/* Template Chooser */}
                    <FieldContainer sx={{ mb: 2 }}>
                      <SectionLabel>Email Layout Template</SectionLabel>
                      <CustomSelect
                        name="organization"
                        multiple={false}
                        option={EmailTemplateList}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          settemplateData(
                            EmailTemplateList?.find((template) => template._id === e.target.value)
                          );
                        }}
                        fullWidth
                        label="Choose Configuration Template (Optional)"
                      />
                    </FieldContainer>

                    <Divider sx={{ borderColor: "#e2e8f0", mb: 2 }} />

                    {/* Sender View */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
                      <Avatar src="/assest/profile.png" sx={{ width: 32, height: 32, bgcolor: "#0f6cbd" }} />
                      <Box>
                        <Typography fontFamily={FontFamily.Nunito} fontSize="14px" fontWeight={fontWeight.W600} color="#201f1e">
                          {window.sessionStorage.getItem("user_email") || "SelfEmail@gmail.com"}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Internal User Automation */}
                    <FieldContainer>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography fontFamily={FontFamily.Nunito} fontSize="14px" fontWeight={600} color="#605e5c" sx={{ minWidth: "60px" }}>
                          To (Internal)
                        </Typography>
                        <Box sx={{ flexGrow: 1 }}>
                          <Tempautocomplete onSelectionChange={handleSelectionChange} />
                        </Box>
                      </Box>

                      {/* Interactive Selection Groups */}
                      {selections?.length > 0 && (
                        <Box sx={{ p: 2, bgcolor: "#f8fafc", borderRadius: "12px", border: "1px solid #e2e8f0", mt: 1 }}>
                          {renderChipGroup("to", "Direct Recipients (To)")}
                          {renderChipGroup("cc", "Carbon Copy (CC)")}
                          {renderChipGroup("bcc", "Blind Carbon Copy (BCC)")}
                        </Box>
                      )}
                    </FieldContainer>

                    {/* External User Fallback */}
                    <FieldContainer>
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                        <Typography fontFamily={FontFamily.Nunito} fontSize="14px" fontWeight={600} color="#605e5c" sx={{ minWidth: "60px", mt: 1.5 }}>
                          To (External)
                        </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 1,
                          p: "6px 12px",
                          border: "1px solid #cbd5e1",
                          borderRadius: "8px",
                          backgroundColor: "#ffffff",
                          minHeight: "44px",
                          alignItems: "center",
                          transition: "all 0.2s",
                          "&:focus-within": {
                            borderColor: "#0f6cbd",
                            boxShadow: `0 0 0 1px #0f6cbd`,
                          },
                        }}
                      >
                        {/* Render individual chips for already staged external emails */}
                        {values.otherto!="" ? values.otherto.split(",").filter(Boolean).map((email, index) => (
                          <Chip
                            key={index}
                            label={email.trim()}
                            size="small"
                            onDelete={() => {
                              const currentEmails = values.otherto.split(",").filter(Boolean);
                              currentEmails.splice(index, 1);
                              setFieldValue("otherto", currentEmails.join(","));
                            }}
                            deleteIcon={<CloseIcon sx={{ fontSize: "14px !important" }} />}
                            sx={{
                              background: "#f1f5f9",
                              borderRadius: "6px",
                              border: "1px solid #e2e8f0",
                              "& .MuiChip-label": { fontFamily: FontFamily.Nunito, fontWeight: fontWeight.W600, color: "#334155" },
                            }}
                          />
                        )) : null}

                        {/* Naked Input Field for typing */}
                        <input
                          type="text"
                          placeholder={!values.otherto ? "example@externaldomain.com, external2@domain.com" : ""}
                          style={{
                            border: "none",
                            outline: "none",
                            flexGrow: 1,
                            fontFamily: FontFamily.Nunito,
                            fontSize: "14px",
                            color: "#1e293b",
                            minWidth: "180px",
                            height: "26px"
                          }}
                          onKeyDown={(e) => {
                            const rawValue = e.target.value.trim();

                            // Intercept Enter key or Comma key inputs
                            if (e.key === "Enter" || e.key === ",") {
                              e.preventDefault(); // Stop form submissions or entering explicit comma characters

                              if (rawValue) {
                                // Clean out trailing characters if necessary
                                const cleanEmail = rawValue.replace(/,/g, "");

                                if (cleanEmail) {
                                  const existingEmails = values.otherto ? values.otherto.split(",").filter(Boolean) : [];

                                  // Check for duplicates before pushing down to string state
                                  if (!existingEmails.includes(cleanEmail)) {
                                    existingEmails.push(cleanEmail);
                                    setFieldValue("otherto", existingEmails.join(","));
                                  }
                                }
                                e.target.value = ""; // Empty out local input buffer
                              }
                            }
                          }}
                          onBlur={(e) => {
                            // Handle fallback parsing if user clicks away while text is half-written
                            const rawValue = e.target.value.trim();
                            if (rawValue) {
                              const cleanEmail = rawValue.replace(/,/g, "");
                              const existingEmails = values.otherto ? values.otherto.split(",").filter(Boolean) : [];
                              if (cleanEmail && !existingEmails.includes(cleanEmail)) {
                                existingEmails.push(cleanEmail);
                                setFieldValue("otherto", existingEmails.join(","));
                              }
                              e.target.value = "";
                            }
                          }}
                        />
                      </Box>
                      </Box>
                    </FieldContainer>
                    <FieldContainer sx={{ mb: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography fontFamily={FontFamily.Nunito} fontSize="14px" fontWeight={600} color="#605e5c" sx={{ minWidth: "60px" }}>
                          Subject
                        </Typography>
                        <Box sx={{ flexGrow: 1 }}>
                          <input
                            type="text"
                            value={values.subject}
                            onChange={handleChange}
                            name="subject"
                            placeholder="Add a subject"
                            style={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #cbd5e1",
                              outline: "none",
                              padding: "12px 0",
                              fontFamily: FontFamily.Nunito,
                              fontSize: "18px",
                              color: "#0f172a",
                              fontWeight: 600,
                              backgroundColor: "transparent",
                              transition: "border-color 0.2s"
                            }}
                            onFocus={(e) => e.target.style.borderBottom = "2px solid #0f6cbd"}
                            onBlur={(e) => e.target.style.borderBottom = "1px solid #cbd5e1"}
                          />
                        </Box>
                      </Box>
                    </FieldContainer>

                    <FieldContainer sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                      <Box sx={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid #cbd5e1",
                        borderRadius: "8px",
                        overflow: "hidden",
                        transition: "all 0.2s",
                        "&:focus-within": { borderColor: "#0f6cbd", boxShadow: "0 0 0 1px #0f6cbd" },
                        "& .wrapperClassName": { display: "flex", flexDirection: "column", flexGrow: 1 },
                        "& .toolbarClassName": { borderBottom: "1px solid #e2e8f0", borderTop: "none", background: "#f8fafc !important", p: "8px 12px" },
                        "& .editorClassName": { minHeight: "250px", padding: "16px 24px", fontFamily: FontFamily.Nunito, color: "#334155", fontSize: "15px", backgroundColor: "#ffffff" }
                      }}>
                        <Editor
                          editorState={editorState}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          placeholder="Begin crafting your professional transmission content here..."
                          onEditorStateChange={(state) => {
                            setEditorState(state);
                            const html = draftToHtml(convertToRaw(state.getCurrentContent()));
                            setB_Description(html);
                            setFieldValue("body", html);
                          }}
                        />
                        {originalHtml && (
                          <Box sx={{ 
                            px: 3, 
                            pb: 3, 
                            pt: isForward ? 0 : 2,
                            borderTop: isForward ? "none" : "1px solid #e2e8f0",
                            bgcolor: "#ffffff",
                            overflowY: "auto", 
                            maxHeight: "500px" 
                          }}>
                            {!isForward && <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#94a3b8", mb: 2, textTransform: "uppercase", letterSpacing: "0.5px" }}>Original Message</Typography>}
                            <div 
                              style={{ fontFamily: '"Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif', color: '#475569', fontSize: '14px', lineHeight: '1.6' }}
                              dangerouslySetInnerHTML={{ __html: originalHtml }} 
                            />
                          </Box>
                        )}
                      </Box>
                    </FieldContainer>

                    {/* Bottom Action Bar */}
                    <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={formLoading}
                          sx={{
                            bgcolor: "#0f6cbd",
                            color: "#ffffff",
                            p: "8px 24px",
                            borderRadius: "4px",
                            fontFamily: FontFamily.Nunito,
                            fontWeight: 600,
                            textTransform: "none",
                            fontSize: "14px",
                            boxShadow: "none",
                            "&:hover": { bgcolor: "#0c5399", boxShadow: "none" }
                          }}
                        >
                          {formLoading ? "Sending..." : "Send"}
                        </Button>

                        <Button
                          variant="outlined"
                          startIcon={<AccessTimeRoundedIcon fontSize="small" />}
                          onClick={handleOpen}
                          sx={{
                            borderColor: "#cbd5e1",
                            color: "#475569",
                            p: "7px 16px",
                            borderRadius: "4px",
                            fontFamily: FontFamily.Nunito,
                            fontWeight: 600,
                            textTransform: "none",
                            fontSize: "14px",
                            "&:hover": { borderColor: "#94a3b8", bgcolor: "#f8fafc" }
                          }}
                        >
                          Schedule
                        </Button>
                      </Box>

                      {/* Attachments Dropzone (Small Area) */}
                      <Box sx={{ width: '100%', border: "1px dashed #cbd5e1", borderRadius: "8px", p: 1, bgcolor: "#fafafa" }}>
                        <Previews
                          deleteShow={true}
                          ref={childRef}
                          initialValue={values?.attachments}
                          handleMydropzoneFile={(updatedFiles) => {
                            setFieldValue("attachments", updatedFiles);
                          }}
                        />
                      </Box>
                    </Box>

                  </Stack>
                </FormSectionCard>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>

      {/* Date-Picker Workflow Dialog */}
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <FormGroup>
            <Stack spacing={3}>
              <Box>
                <Typography fontFamily={FontFamily.Poppins} fontWeight={fontWeight.W600} fontSize="18px" color="#0f172a">
                  Deffered System Delivery
                </Typography>
                <Typography fontFamily={FontFamily.Poppins} fontSize="13px" color="#64748b">
                  Set target date parameters to execute automated cron routing.
                </Typography>
              </Box>

              <MyDatePicker
                minDate={dayjs().startOf("day")}
                label="Target Processing Timestamp"
                onChange={(date) => {
                  setReminderdatatime(dayjs(date).format("YYYY-MM-DD HH:mm"));
                }}
              />

              <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 1 }}>
                <Button onClick={handleClose} sx={{ color: "#64748b", fontFamily: FontFamily.Poppins, textTransform: "none" }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleReminderSave}
                  sx={{ bgcolor: ThemeColor.PURPLE, "&:hover": { bgcolor: "#6d28d9" }, fontFamily: FontFamily.Poppins, textTransform: "none", borderRadius: "8px" }}
                >
                  Confirm & Schedule
                </Button>
              </Stack>
            </Stack>
          </FormGroup>
        </Box>
      </Modal>
    </Box>
  );
};

function AddNewMail() {
  return <ResponsiveDrawer maincontent={<AddNewMailPage />} />;
}

export default AddNewMail;